export default __webpack_public_path__ + "static/media/bg.eac855c3.png";